import { TDeviceType } from '@cian/ui-kit';
import { clsx as cn } from 'clsx';
import * as React from 'react';

import * as styles from './Content.css';

interface IContentProps {
  deviceType: TDeviceType;
}

export const Content: React.FC<React.PropsWithChildren<IContentProps>> = ({ children, deviceType }) => (
  <main className={cn(styles['content'], styles[`content-${deviceType}`])}>
    <div className={cn(styles['content-container'], styles[`content-container-${deviceType}`])}>{children}</div>
  </main>
);
